export default "__VITE_ASSET__99233c7c__"